import React from "react";
import { Title } from "../../components/Title";
import { CardThree } from "../../components/Card/CardThree";
import { useTranslation } from "react-i18next";
import "./styles.less";

export const DeveloperThirdLogin = () => {
  const { t } = useTranslation();
  const cards = [
    {
      title: `${t("developer.thirdLogin.item0.title")}`,
      subtitle: `${t("developer.thirdLogin.item0.subtitle")}`,
      link: "https://docs.authing.cn/v2/guides/authentication/social/",
    },
    {
      title: `${t("developer.thirdLogin.item1.title")}`,
      subtitle: `${t("developer.thirdLogin.item1.subtitle")}`,
      link: "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-webpage-authorization.html",
    },

    {
      title: `${t("developer.thirdLogin.item2.title")}`,
      subtitle: `${t("developer.thirdLogin.item2.subtitle")}`,
      link: "https://docs.authing.cn/v2/connections/oidc/",
    },
    {
      title: `${t("developer.thirdLogin.item3.title")}`,
      subtitle: `${t("developer.thirdLogin.item3.subtitle")}`,
      link: "https://docs.authing.cn/v2/federation/oauth2/authorization-code/",
    },
    {
      title: `${t("developer.thirdLogin.item4.title")}`,
      subtitle: `${t("developer.thirdLogin.item4.subtitle")}`,
      link: "https://docs.authing.cn/v2/connections/saml/",
    },
    {
      title: `${t("developer.thirdLogin.item5.title")}`,
      subtitle: `${t("developer.thirdLogin.item5.subtitle")}`,
      link: "https://docs.authing.cn/v2/connections/ldap",
    },
    {
      title: `${t("developer.thirdLogin.item6.title")}`,
      subtitle: `${t("developer.thirdLogin.item6.subtitle")}`,
      link: "https://docs.authing.cn/v2/guides/users/ldap-user-directory.html",
    },
  ];
  return (
    <div>
      <section className="developer-thirdparty-login" id="thirdLogin">
        <div className="inner">
          <Title title={t("developer.thirdLogin.title")}></Title>
          <div className="developer-content">
            {cards.map((item) => {
              return <CardThree title={item.title} subtitle={item.subtitle} link={item.link} />;
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
